import { ArrowRight, Loader2 } from 'lucide-react';
import { Button } from '@/components/Button';
import {
  CHECK_IN_PROMPTS,
  type CheckInResponseCreateInput,
} from '@/entities/check-in-response';
import { PromptField } from './PromptField';

interface CheckInFormProps {
  hasInsights?: boolean;
  responses: CheckInResponseCreateInput;
  onResponseChange: (key: string, value: string) => void;
  onSubmit: () => void;
  isPending: boolean;
  error: Error | null;
}

export function CheckInForm({
  hasInsights,
  responses,
  onResponseChange,
  onSubmit,
  isPending,
  error,
}: CheckInFormProps) {
  return (
    <div className="flex flex-1 flex-col gap-10">
      {CHECK_IN_PROMPTS.map((prompt) => (
        <PromptField
          key={prompt.key}
          id={`prompt-${prompt.key}`}
          label={prompt.text}
          value={responses[prompt.key] ?? ''}
          autoFocus
          placeholder="Whatever comes to mind..."
          onChange={(value) => {
            onResponseChange(prompt.key, value);
          }}
        />
      ))}

      {error && (
        <p className="text-destructive text-sm">
          Something went wrong. Please try again.
        </p>
      )}

      <div className="flex-1" />
      <div className="sticky bottom-[100px] flex flex-col gap-4">
        <hr className="border-gray-200" />
        <Button
          variant="outline"
          onClick={onSubmit}
          disabled={isPending}
          className={`transition-colors duration-300 ${hasInsights ? 'border-blue-300 bg-blue-200 hover:border-blue-400 hover:bg-blue-300' : 'bg-gray-50'}`}
        >
          {isPending ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              Review today&#39;s plan
              <ArrowRight className="h-4 w-4" />
            </>
          )}
        </Button>
      </div>
    </div>
  );
}
